import script from "./ServicesP.vue?vue&type=script&setup=true&lang=js"
export * from "./ServicesP.vue?vue&type=script&setup=true&lang=js"

import "./ServicesP.vue?vue&type=style&index=0&id=08c5cfea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08c5cfea"]])

export default __exports__